import { DefaultStyle, SamplesStyle, SamplesOrangeStyle, SamplesYellowStyle } from "./features/map"
import Hash from './shared/Hash';

export const Config = {

    path: "/product/izhsnotcadaster/",

    metricModuleId: "CadasterIZHS",

    texts: {
        appName: "ИЖС не на кадастре",
        title: ['Находим незарегистрированные ИЖС', 'и резервы налогов на недвижимость'],
        subtitle: [],
        textInfos: [
            {
                upper: '',
                title: 'Что это?',
                text: [
                    'Автоматизированное обнаружение ИЖС, не учтенных в ЕГРН, либо учтенных с заниженной площадью, на большей части территории РФ.',
                    'Найденные нарушения передаются в муниципалитеты для стимулирования  и принуждения собственников  к постановке на  кадастровый учет для повышения налоговой базы и пополнения муниципального бюджета.',
                    '',
                    'Точность обнаружения по результатам верификации на территории Самарской области составляет 70-75%.'
                ]
            },
            {
                upper: '',
                title: 'Как работает?',
                text: [
                    'Основывается на технологии «Робот-картограф», соединяющей геоданные и адресные данные более чем из 10 источников, включая данные Единого государственного реестра недвижимости.',
                    'Из построек, обладающих признаками ИЖС, выделяются три «перспективные» категории:',
                    '- не внесены в ЕГРН и находятся вне земельных участков с координатами (возможен муниципальный земельный контроль)',
                    '- не внесены в ЕГРН  и находятся внутри земельных участков (работа с собственниками)',
                    '- фактическая площадь более чем в 3 раза превышает площадь по документам в ЕГРН.',
                    'Затем для каждого «перспективного» объекта рассчитывается резерв с учетом налогового вычета 50 м² и формируется выходной набор данных.'
                ]
            },
            {
                upper: '',
                title: 'Как использовать?',
                text: [
                    '1. Проверить Ваш регион или муниципалитет, посмотреть статистику по найденным нарушениям и оценке дополнительных налогов, образец (пример) реальных данных по городу Самаре.',
                    '2. Оставить свои контакты и получить бесплатный фрагмент карты по Вашему городу или региону и бесплатную презентацию с техническими подробностями по его обработке.',
                    '3. Заказать полный набор данных и/или сервис.'
                ]
            }
        ],
        footer: {
            text: ["Всего по России 2.9 млн нарушений", "на 11.7 млрд рублей в год"]
        },
        report: {
            button: "Отчет",
            header: "Отчет по территории",
            hint: "Оставьте свои контакты, мы свяжемся с вами",
            thanks: "Мы с вами свяжемся!",
            noRegionStub: "или обсудить любые другие вопросы",
            placeholder: "Почта или телефон",
            whereFromPlaceholder: "Откуда вы",
            request: "Запросить отчет"
        },
        drawing: {
            default: 'Проверить вашу территорию',
            start: 'Указать территорию',
            stop: 'Прекратить рисование'
        }
    },

    layers: [
        {
            id: "regions",
            label: "Регионы",
            url: "https://rk.geosamara.ru/mvtserver/RN_1_143/{z}/{x}/{y}.pbf",
            maxZoom: 10,
            style: (p) => {
                return (p.properties_.level === 1) && ((p.properties_.count > 0) || (p.properties_.insideZuCount > 0) || (p.properties_.underCount > 0)) ? DefaultStyle : undefined;
            },
            turned: true
        },
        {
            id: "municipalitets",
            label: "Муниципалитеты",
            url: "https://rk.geosamara.ru/mvtserver/RN_1_143/{z}/{x}/{y}.pbf",
            maxZoom: 10,
            style: (p) => {
                return (p.properties_.level === 2) && ((p.properties_.count > 0) || (p.properties_.insideZuCount > 0) || (p.properties_.underCount > 0)) ? DefaultStyle : undefined;
            },
            turned: false
        },
        {
            id: "settlements",
            label: "Поселения",
            url: "https://rk.geosamara.ru/mvtserver/RN_1_143/{z}/{x}/{y}.pbf",
            maxZoom: 10,
            style: (p) => {
                return (p.properties_.level === 3) && ((p.properties_.count > 0) || (p.properties_.insideZuCount > 0) || (p.properties_.underCount > 0)) ? DefaultStyle : undefined;
            },
            turned: false
        },
        {
            id: "samples",
            label: "Образец настоящих данных",
            url: "https://rk.geosamara.ru/mvtserver/RN_1_161/{z}/{x}/{y}.pbf",
            maxZoom: 17,
            style: (p) => {
                if (p.properties_.violationByArea) {
                    return SamplesYellowStyle;
                } else {
                    let sources = (p.properties_.allVertexesGrouped && JSON.parse(p.properties_.allVertexesGrouped)) || {};
                    if (sources.lands) {
                        return SamplesOrangeStyle;
                    } else {
                        return SamplesStyle;
                    }
                }
            },
            turned: false,
            afterTurned: (view) => {
                view.setCenter([5603871, 7029312]); //Самара
                //view.setCenter([5484036, 7526269]); //Казань
                view.setZoom(15);
            }
        },

    ],
    featureInfo: {
        properties: [
            { name: 'ИЖС, не учтенных в ЕГРН', field: "count", unit: "шт", style: { fontSize: '40px', color: '#D10015' } },
            { name: 'Оценка дополнительного налога', field: "totalTax", divisor: 1000000, round: 3, unit: "млн.руб/год", style: { fontSize: '40px', color: '#D10015' } },
            //{ name: 'Налогооблагаемая площадь', field: "taxSquare", unit: "м²", style: { fontSize: '30px' } },
            //{ name: 'Оценка общей кадастровой стоимости', field: "totalCost", divisor: 1000000, unit: "млн.руб.", style: { fontSize: '30px' } },

            { name: 'ИЖС не в ЕГРН внутри ЗУ', field: "insideZuCount", unit: "шт", style: { fontSize: '40px', color: '#FF6A00' } },
            { name: 'Оценка дополнительного налога', field: "insideZuTotalTax", divisor: 1000000, round: 3, unit: "млн.руб/год", style: { fontSize: '40px', color: '#FF6A00' } },

            { name: 'ИЖС в ЕГРН со значительно заниженной площадью', field: "underCount", unit: "шт", style: { fontSize: '40px', color: '#D8B800' } },
            { name: 'Оценка дополнительного налога', field: "underTotalTax", divisor: 1000000, round: 3, unit: "млн.руб/год", style: { fontSize: '40px', color: '#D8B800' } },
            //{ name: 'Общая площадь таких', field: "underTotalSquare", unit: "м²", style: { fontSize: '30px' } },

            { name: 'Общая площадь не учтенных', field: (p) => { return (p.totalSquare + p.insideZuTotalSquare) ? ((p.totalSquare + p.insideZuTotalSquare) / 1000000).toFixed(3) : null; }, unit: "млн.м²", style: { fontSize: '30px' } },


            {
                name: 'Разновидность нарушения', field: (p) => {
                    let sources = (p.allVertexesGrouped && JSON.parse(p.allVertexesGrouped)) || {};
                    if (!p.level && !p.violationByArea && !sources.lands) { return "не учтен в ЕГРН" }
                }, longText: true, style: { fontSize: '30px', lineHeight: '30px', color: '#D10015' }
            },
            {
                name: 'Разновидность нарушения', field: (p) => {
                    let sources = (p.allVertexesGrouped && JSON.parse(p.allVertexesGrouped)) || {};
                    if (!p.level && !p.violationByArea && sources.lands) { return "не учтен в ЕГРН, но стоит на ЗУ" }
                }, longText: true, style: { fontSize: '30px', lineHeight: '30px', color: '#FF6A00' }
            },
            {
                name: 'Разновидность нарушения', field: (p) => {
                    if (!p.level && p.violationByArea) { return "учтен в ЕГРН, но занижена площадь" }
                }, longText: true, style: { fontSize: '30px', lineHeight: '30px', color: '#D8B800' }
            },

            { name: 'Учтен в ЕГРН с площадью', field: (p) => { if (p.violationByArea) { let v = JSON.parse(p.violationByArea); return v.square } return null; }, unit: "м²", style: { color: '#D8B800' } },

            { name: 'Фактическая площадь', field: "fullArea", unit: "м²" },
            { name: 'Этажность', field: "floors", unit: "" },
            { name: 'Оценка стоимости', field: "costExtimate", divisor: 1000000, round: 3, unit: "млн.руб." },
            { name: 'Оценка дополнительного налога', field: (p) => { return p.taxExtimate ? (p.taxExtimate / 1000).toFixed(1) : null; }, unit: "тыс.руб/год" },
            {
                name: 'Подтверждений по источникам',
                field: (p) => {
                    if (p.allVertexesGrouped) {
                        let sources = JSON.parse(p.allVertexesGrouped) || {};
                        return Object.keys(sources).length;

                    }
                }
            }
        ],
        territoryNameFunc: (properties) => {
            return (properties.Street && properties.HouseNumber) ? properties.Street + ' ' + properties.HouseNumber :
                (properties.level === 2) ? (properties.region + ', ' || '') + (properties.municipalitet || '') :
                    (properties.level === 3) ? (properties.region + ', ' || '') + (properties.municipalitet + ', ' || '') + (properties.settlement || '') :
                        (properties.region || '');
        },
        headerFunc: (properties) => {
            return (properties.Street && properties.HouseNumber) ? properties.Street + ' ' + properties.HouseNumber :
                (properties.level === 2) ? properties.municipalitet :
                    (properties.level === 3) ? properties.settlement : properties.region;
        },
        subHeaderFunc: (properties) => {
            return (properties.Region || properties.Municipalitet) ? ((properties.Region || '') + ', ' + (properties.Municipalitet || '')).replaceAll('(debug)', '') :
                (properties.level === 2) ? properties.region :
                    (properties.level === 3) ? properties.municipalitet + ', ' + properties.region : '';;
        }

    },
    featureId: (feature) => {
        return Hash.SHA1((feature.properties_.clusterID || '') + (feature.properties_.region || '') + (feature.properties_.level || '') + (feature.properties_.municipalitet || '') + (feature.properties_.settlement || ''));
    }
}


